import * as React from 'react';
import { Spinner, Popover, PopoverInteractionKind, H5, Classes, Intent, Button } from '@blueprintjs/core';
import { executeQueryGetAuth, executeQueryPostAuth } from 'app/utils/api';
import { UserState } from 'app/reducers/state';
import ReactTable from 'react-table';
import { filter } from 'lodash';
import { EditButton } from '../EditButton';
import { AddButton } from '../AddButton';
import { StandardInput } from '../StandardInput';
import { ClassOverview } from '../ClassOverview';
import { AddUser } from '../AddUser';
import { ProgressTabs } from '../ProgressTabs';
import * as superagent from 'superagent';
import { Coaching } from '../Coaching';
import { ClassSettingsView } from '../ClassSettingsView';

const KRY_URL = 'https://ajwrrfj6wi.execute-api.us-east-1.amazonaws.com/prod/';

interface Props {
    user: UserState;
    onClassAction?: any;
};

interface State {
    loadingData: boolean;
    classToManage: string;
    allClassess: any;
    _newSchool: string;
    _newCode: string;
    _newClass: string;
    gameIDInput: string;
    ranGameSet: any[];
    coachingClass: string;
}

export class ClassAdmin extends React.Component<Props, State> {

    state: State = {
        loadingData: true,
        allClassess: [],
        classToManage: "",
        _newSchool: "",
        _newClass: "",
        _newCode: "",
        gameIDInput: '',
        ranGameSet: [],
        coachingClass: ''
    }

    componentDidMount() {
        this.initClassData();
    }

    initClassData = () => {
        this.setState({
            loadingData: true
        });

        executeQueryGetAuth("class", {}, this.props.user, (data) => {
            let incomingData = data.body;

            for (let i = 0; i < incomingData.length; i++) {
                incomingData[i].name = incomingData[i].first + " " + incomingData[i].last + " (" + incomingData[i].email + ")";
            }

            // Filter out hidden classes (enrollment_hidden != 0)
            incomingData = filter(incomingData, data => {
                return parseInt(data['enrollment_hidden']) == 0;
            });

            this.setState({
                loadingData: false,
                allClassess: incomingData
            });
        });
    }

    handleRunGame = (gameID: string, rounds: number) => {
        let newRoundSet: any[] = [];

        for (let i = 0; i < rounds; i++) {
            newRoundSet.push({
                round: i,
                loading: true
            });
        }

        this.setState({
            ranGameSet: newRoundSet
        }, () => {

            let promises: any[] = [];

            for (let i = 0; i < rounds; i++) {
                promises.push(
                    new Promise((resolve, reject) => {
                        try {
                            const href = KRY_URL + 'kry?gameID=' + gameID + '&isToGetGame=true&round=' + i.toString();

                            superagent.
                                get(href).
                                end((error: any, response: any) => {
                                    try {
                                        resolve({
                                            round: i, loading: false, response: JSON.parse(response.text)
                                        });
                                    }
                                    catch (z) {
                                        resolve({
                                            round: i, loading: true
                                        });
                                    }
                                });
                        }
                        catch (e) {
                            resolve({
                                round: i, loading: true
                            });
                        }
                    })
                );
            }

            Promise.all(promises).then((result) => {
                this.setState({
                    ranGameSet: result
                });
            });
        });
    }

    handleAddClass = (school: string, _class: string, code: string) => {
        this.setState({
            loadingData: true
        });

        executeQueryPostAuth("class", {
            name: _class,
            school,
            code
        }, this.props.user, (response) => {
            this.setState({
                _newClass: "",
                _newCode: "",
                _newSchool: ""
            });

            this.initClassData();
        });
    }

    renderAddButton = () => {
        const {
            _newClass,
            _newCode,
            _newSchool
        } = this.state;

        return <Popover
            canEscapeKeyClose={true}
            interactionKind={PopoverInteractionKind.CLICK}
        >
            <AddButton label="New Class" />
            <div key="text" style={{ display: 'block', padding: '20px', marginBottom: '20px' }}>
                <H5>New Class</H5>
                <p>
                    <StandardInput
                        autoFocus={true}
                        onChange={(value) => { this.setState({ _newClass: value.target.value }); }}
                        type={"text"}
                        value={_newClass}
                        label={"Class Name"} />
                    <StandardInput
                        autoFocus={false}
                        onChange={(value) => { this.setState({ _newCode: value.target.value }); }}
                        type={"text"}
                        value={_newCode}
                        label={"Class Code"} />
                    <StandardInput
                        autoFocus={false}
                        onChange={(value) => { this.setState({ _newSchool: value.target.value }); }}
                        type={"text"}
                        value={_newSchool}
                        label={"University Name"} />
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                    <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>
                        Cancel
                    </Button>
                    <Button intent={Intent.PRIMARY} className={Classes.POPOVER_DISMISS} onClick={() => {
                        this.handleAddClass(_newSchool, _newClass, _newCode);
                    }}>
                        Save
                    </Button>
                </div>
            </div>
        </Popover>
    }

    renderAddUserButton = () => {
        return <span style={{ display: 'block', marginBottom: '20px' }}>
            <AddUser
                user={this.props.user}
                onSaved={() => {
                    this.initClassData();
                }}
                onSaving={() => {
                    this.setState({
                        loadingData: true
                    });
                }}
            />
        </span>
    }

    getIsThereNoClassToManage = () => {
        const {
            classToManage
        } = this.state;

        if (classToManage === undefined || classToManage === "") {
            return true;
        }

        return false;
    }

    renderSelectedClass = () => {
        const {
            classToManage
        } = this.state;

        const {
            user
        } = this.props;

        if (classToManage === undefined || classToManage === "") {
            return <span></span>
        }

        return <span style={{ display: 'block', marginTop: '20px' }}>
            <Button intent={Intent.NONE} text="Back" onClick={() => {
                this.setState({
                    classToManage: ""
                });
            }} />
            <br />
            <ClassOverview stoppedLoadingData={() => { }} startLoadingData={() => { }} selectedClass={classToManage} user={user} />
            <hr />
            <ProgressTabs classID={classToManage} user={user} />
        </span>
    }

    renderCharacter = (payload, character) => {
        const char = payload.characters[character];

        if (char['focal'] === "True" || char['focal'] === true) {
            return <td>{JSON.stringify(char['action'])}</td>
        }
        else {
            return <td>{"-"}</td>
        }
    }

    renderSinglePayload = (round, loading, payload) => {
        let entries: JSX.Element[] = [];

        entries.push(<td>{round}</td>);
        entries.push(<td>{loading}</td>);

        entries.push(this.renderCharacter(payload, 'Oli'));
        entries.push(this.renderCharacter(payload, 'Rosa'));
        entries.push(this.renderCharacter(payload, 'Will'));
        entries.push(this.renderCharacter(payload, 'Herman'));

        return <tr>
            {entries}
        </tr>
    }

    renderClassReport = (coachingClass: string) => {
        return <Coaching
            user={this.props.user}
            selectedClass={coachingClass}
        />
    }

    render() {
        const {
            loadingData,
            allClassess,
            coachingClass
        } = this.state;

        if (loadingData) {
            return <Spinner />
        }

        if (coachingClass !== "" && coachingClass !== undefined) {
            return this.renderClassReport(coachingClass);
        }

        const columns = [
            {
                Header: "Professor",
                accessor: "name",
                width: 150
            },
            {
                Header: "Course",
                accessor: "class",
                width: 300
            },
            {
                Header: "School",
                accessor: "school",
                width: 200
            },
            {
                Header: "Class ID",
                accessor: "id",
                width: 80
            },
            {
                Header: "Coaching Report",
                accessor: "id",
                Cell: (props) => {
                    const query = `https://tgwz7xpofb.execute-api.us-east-1.amazonaws.com/dev/build?classID=${props.value}`;

                    return <Button onClick={() => {
                        window.open(query, "_blank");
                    }}>Download</Button>;
                }
            },
            {
                Header: "Settings",
                accessor: "id",
                Cell: (props) => {
                    const settingsWidget = <ClassSettingsView saOnly={true} fullWidth={true} classID={props.value} user={this.props.user} />;

                    return <Popover
                        canEscapeKeyClose={true}
                    >
                        <Button intent={Intent.NONE} text="Settings" tabIndex={0} />
                        <div key="text" style={{ display: 'block', padding: '20px', marginBottom: '20px' }}>
                            {settingsWidget}
                        </div>
                    </Popover>
                }
            },
            {
                Header: "Portal Report",
                accessor: "id",
                Cell: (props) => {
                    return <Button onClick={() => {
                        this.setState({
                            coachingClass: props.value
                        });
                    }}>Coach</Button>;
                }
            },
            {
                Header: "",
                accessor: "id",
                Cell: (props) => {
                    return <EditButton label="Manage" onPress={() => {
                        this.setState({
                            classToManage: props.value
                        });
                    }} />
                }
            }
        ]

        return <span>
            {this.getIsThereNoClassToManage() ? <div>
                {this.renderAddUserButton()}
                {this.renderAddButton()}
                <ReactTable style={{ marginTop: '20px' }} columns={columns} data={allClassess} pageSize={allClassess.length} showPagination={false} showPageSizeOptions={false} /> 
            </div> : undefined}
            {this.renderSelectedClass()}
        </span>
    }
}
